import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { HomeIcon, LockIcon } from 'lucide-react';
const OFFER_URL = 'https://trackrt.activapleno.com/click';
export function MicroCommitment() {
  const handleClick = () => {
    window.location.href = OFFER_URL;
  };
  return <FadeIn data-id="element-62">
      <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 md:p-10 text-center mb-16 shadow-sm" data-id="element-63">
        <div className="inline-flex items-center justify-center bg-amber-100 text-amber-800 px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-64">
          Homeowners qualify for exclusive local pricing
        </div>
        <HomeIcon className="w-10 h-10 text-[#F5A623] mx-auto mb-4" data-id="element-65" />
        <h3 className="text-2xl md:text-3xl font-bold text-[#111] mb-2" data-id="element-66">
          Quick question:
        </h3>
        <p className="text-xl text-[#444] mb-8" data-id="element-67">Do you own your home?</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-68">
          <button onClick={handleClick} className="w-full sm:w-auto font-bold text-white bg-[#F5A623] hover:bg-[#D4891A] text-lg py-4 px-12 rounded-xl transition-all duration-200 shadow-[0_4px_14px_0_rgba(245,166,35,0.4)] hover:shadow-[0_6px_20px_rgba(245,166,35,0.25)] hover:-translate-y-0.5 active:translate-y-0 cursor-pointer" data-id="element-69">
            Yes, I own my home
          </button>
          <button onClick={handleClick} className="w-full sm:w-auto font-bold text-[#444] bg-white border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 text-lg py-4 px-12 rounded-xl transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 cursor-pointer" data-id="element-70">
            No, I'm renting
          </button>
        </div>

        <div className="flex items-center justify-center gap-1.5 text-sm text-gray-500" data-id="element-71">
          <LockIcon className="w-4 h-4" data-id="element-72" />
          <span data-id="element-73">No personal info required to check prices</span>
        </div>
      </div>
    </FadeIn>;
}